import React                 from 'react';
import { observer, inject  } from 'mobx-react';

import { Menu              } from './commun/Menu';
import { Bandeau           } from './commun/Bandeau';
import { BandeauSmartphone } from './commun/BandeauSmartphone';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                                 JDR                           ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export const JDR = inject(['store'])(observer(class JDR extends React.Component {

  /* ---------------------- */
  /* Affichage du composant */
  /* ---------------------- */

  render() {

    const largeur = this.props.store.largeurBandeau + 'px' ;

    /* ------------------------------ */
    /* Définition des CSS d'affichage */
    /* ------------------------------ */

    const styleBlocTexte = window.innerWidth < 1080 ? 
        {
          width        : (window.innerWidth - 20) + "px",
          display      : "block",
          marginTop    : "20px",
          marginBottom : "10px"
      }
      : 
      {
        width           : this.props.largeur ? this.props.largeur : "1063px",
        display         : "block",
        marginTop       : "30px",
        marginLeft      : "auto",
        marginRight     : "auto",
        marginBottom    : "10px",
        textAlign       : 'center'      
    };

    /* ----------------------------------------- */
    /* Définition de l'onglet du menu à afficher */
    /* ----------------------------------------- */

    this.props.store.definirSelectionOnglet ("jdr");

    /* ------------------------------- */
    /* Définition du titre de l'onglet */
    /* ------------------------------- */

    document.title = "Le jeu de rôles - La geste d'Aros";

    /* -------------------------------- */
    /* Formatage des données à afficher */
    /* -------------------------------- */

    const nomImage = window.innerWidth < 1080 ? "travauxSmartphone" : "travaux";
 
    const znBandeau = window.innerWidth < 1080 ?  <BandeauSmartphone /> : <Bandeau largeur={largeur} />;

    /* ------------------- */
    /* Renvoi du composant */
    /* ------------------- */

    return (

        <div id='divJDR' style={{textAlign:'center'}}> 

            {znBandeau}

            <Menu menu = {this.props.store.menu} />

            <div style={styleBlocTexte}>  

                <div className={nomImage}></div>

                <br /><br />  

                {window.innerWidth < 1080 && 
                  <div>
                      <p className="Recit">
                          Cette page n'est <span style={{color:'#FF0000',fontWeight:'bold'}}>pas encore disponible</span>.
                      </p>
                      <p className="Recit">
                        Veuillez nous excuser pour la gêne pccasionnée.
                      </p>
                      <p className="Recit">
                          Comme vous le constatez, nos équipes travaillent d'arrache-pied pour terminer les travaux dans les plus brefs délais et vous permettre d'accéder au contenu de cette page.
                      </p>
                  </div>
                }

                <p className="Recit">
                    Une fois que le malheureux auteur&nbsp;/&nbsp;éditeur&nbsp;/&nbsp;développeur (qui a dit "Compositeur et interprête" ? Mais non voyons !!!) aura réussi à voler un peu de temps pour finaliser son site, le contenu de cette page sera offert à votre insatiable mais néanmoins  légitime curiosité.
                </p>

            </div>
          </div>
      )
    } 
  } // Fin de la classe JDR
))



// WEBPACK FOOTER //
// ./src/components/JDR.js